<template>
    <div class="outer">
        <div class="inner" :style="{width: value + '%', background: color}"></div>
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from "vue-property-decorator";
    @Component
    export default class AppProgressBar extends Vue { 
        @Prop()
        value!: number

        @Prop()
        color!: string
     }
</script>

<style scoped>
    .outer {
        border-radius: 0;
        width: 100%;
        height: 6px;
        background: #00000010;
    }
    .inner {
        min-width: 1%;
        height: 100%;
        transition: 1s;
    }
</style>